import { render } from "./edit-prescription.vue?vue&type=template&id=328920fe"
import script from "./edit-prescription.vue?vue&type=script&lang=js"
export * from "./edit-prescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__